import React, { useState } from 'react'
import Divider from '../../../../ui/Divider'
import InputField from '../../../../ui/InputField'
import Icon from 'UI/FontAwesomeIcon'
import { CREATE_CREDENTIAL_COMPONENT } from '../queries'
import { Query } from '../../../../utilities/incognitaAPI'
import { isEmpty } from 'lodash'
import { Alert } from 'react-bootstrap'

const CreateCredential = ({ getCredentials }) => {
  const [alert, setAlert] = useState({})
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [credentialType, setCredentialType] = useState('')
  const [credentialValue, setCredentialValue] = useState('')

  const create = () => {
    setLoading(true)

    Query(CREATE_CREDENTIAL_COMPONENT, {
      serviceName: 'Logicmonitor',
      credentialType,
      value: credentialValue
    }).then(res => {
      if (isEmpty(res.createCredentialComponent.errors)) {
        getCredentials()
        setErrors({})
        setAlert({
          text: 'Credential has been successfully created!',
          variant: 'success'
        })
      } else {
        setErrors(res.createCredentialComponent.errors)
      }
    }).finally(() => setLoading(false))
  }

  return (
    <div>
      {alert.text && (
        <Alert
          variant={alert.variant}
          dismissible
          onClose={() => setAlert({})}
        >
          {alert.text}
        </Alert>
      )}

      <div className="flex mb-2">
        <InputField
          className="mr-2 w-full"
          value={credentialType}
          onChange={e => setCredentialType(e.target.value)}
          label="Credential Type"
          error={errors.credentialType}
        />

        <InputField
          className="w-full"
          value={credentialValue}
          onChange={e => setCredentialValue(e.target.value)}
          label="Name"
          error={errors.value}
        />
        
        <div className="mt-8 mx-2">
          <Icon
            className={`text-2xl duration-300 hover:text-blue-600 ${loading ? 'animate-spin text-blue-600' : 'text-gray-400 cursor-pointer' }`}
            icon={loading ? 'spinner' : 'plus-circle'}
            onClick={create}
          />
        </div>
      </div>
    </div>
  )
}

export default CreateCredential